import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted'
import HelpRounded from '@material-ui/icons/HelpRounded'
import BFTabs from '../components/Tabs/BFTabs'
import BFTab from '../components/Tabs/BFTab'
import PortfolioTodayMobile from '../containers/PortfolioTodayMobile'
import PortfolioLastWeekMobile from '../containers/PortfolioLastWeekMobile'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { getCookie, setCookieHelper } from '../ultils/cookie'
import { userService } from '../services/users.services'
import { EXPIRED_SECOND } from '../constants/Cookie'
import {
  HOME_PATHNAME,
  PORTFOLIO_HOME_PATHNAME,
  PORTFOLIO_LAST_WEEK_PATHNAME,
  PORTFOLIO_SINGLE_PATHNAME,
} from '../constants/RoutePathName'
import { clearD3Tips } from '../ultils/dataUtil'
import ResponsiveArticle from '../components/ResponsiveArticle'
import PortfolioTooltipModal from '../components/PortfolioTooltipModal'

const useStyles = makeStyles({
  container: {
    padding: '0px 20px',
    marginBottom: '30px',
  },
  toolbar: {
    padding: '20px 55px 0px 55px',
  },
  pageTitle: {
    flex: '1 1 100%',
  },
  filterContainer: {
    width: 200,
  },
  toolTip: {
    color: '#8D9CB1',
    width: 20,
    height: 20,
    fontSize: 20,
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginLeft: 5,
  },
  subTitle: {
    marginBottom: 15,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    color: '#5E5E5E',
  },
  portfolioTable: {
    backgroundColor: '#fff',
    padding: '20px 25px',
    border: '1px solid #DFE4EB',
    marginTop: '40px',
    borderRadius: 5,
    marginBottom: 35,
  },
  greet: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '22px',
    color: '#181818',
  },
  title: {
    fontWeight: 400,
    fontSize: 20,
    lineHeight: '24.2px',
    color: '#1B3963',
  },
  headPage: {
    height: '60px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 14,
  },
  emptyBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '213px 0px',
  },
  emptyIcon: {
    marginBottom: 23,
  },
  noavailableText: {
    fontSize: 24,
    lineHeight: '24px',
    fontWeight: 600,
    color: '#5E5E5E',
  },
  legendWrapper: {
    width: '200px',
  },
  tabsGroup: {
    flex: '1 1 0',
    minWidth: 0,
    height: 42,
    padding: 4,
    borderRadius: 3,
    background: '#FFFFFF',
    border: 'none',
    boxSizing: 'border-box',
    minHeight: 'unset',
    '& .MuiTabs-flexContainer': {
      gap: 4,
      minWidth: 0,
    },
    '& .MuiTab-root.small': {
      minWidth: 0,
      flex: '1 1 0',
      maxWidth: 'none',
      height: 32,
      padding: '5px 2px',
      borderRadius: 3,
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      fontSize: 13,
      lineHeight: '20px',
      textTransform: 'none',
    },
    '& .MuiTab-root.small .MuiTab-wrapper': {
      width: '100%',
      padding: '0 !important',
      color: '#757575',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '@media (max-width: 360px)': {
      '& .MuiTab-root.small': {
        fontSize: 12,
        padding: '4px 2px',
      },
    },
    '& .MuiTab-root.small.Mui-selected': {
      background: '#1B3963',
      color: '#FFFFFF',
    },
    '& .MuiTab-root.small.Mui-selected .MuiTab-wrapper': {
      color: '#FFFFFF',
    },
  },
  searchCommonContainer: {
    width: 250,
    marginLeft: 14,
  },
  tabsLabel: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    color: '#474747',
    paddingRight: '16px',
  },
  spinnerContainer: {
    width: '100%',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  portfolioListContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#1B3963',
    padding: '0 12px',
    height: 40,
    borderRadius: 3,
    cursor: 'pointer',
    flex: '0 0 auto',
  },
  portfolioListTitle: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 600,
    color: '#FFFFFF',
    marginLeft: 8,
  },
  FormatListBulletedIcon: {
    color: 'white',
    width: 22,
  },

  pMobileControlCombo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  pMPortfolioTitle: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '28px',
    color: '#181818',
  },
})

const getToggleValue = (pathname: string) => {
  switch (pathname) {
    case HOME_PATHNAME:
      return 0
      break
    case PORTFOLIO_HOME_PATHNAME:
      return 0
      break
    case PORTFOLIO_SINGLE_PATHNAME:
      return 0
      break
    case PORTFOLIO_LAST_WEEK_PATHNAME:
      return 1
      break
    default:
      return 0
  }
}

const PortfolioPageMobile = (props: any) => {
  const history = useHistory()
  const classes = useStyles()
  const {
    state,
    getTickersOnlyInPortfolio,
    getAllTickersInUniverse,
    changeSelectedTab,
    changeSelectedRiskTab,
    cleanUp,
  } = useContext(PortfolioContext)
  const [selectedTab, setSelectedTab] = useState(state.selectedTab)
  const [selectedRiskTypeTab, setSelectedRiskTypeTab] = useState(
    state.selectedRiskTypeTab,
  )
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const handleClickOpenTooltip = () => {
    setOpenTooltip(true)
  }
  const changeRiskTypeTabView = (
    event: React.ChangeEvent<{}>,
    newValue?: any,
  ) => {
    setSelectedRiskTypeTab(newValue)
    changeSelectedRiskTab(newValue)
  }

  const getAllTickersInUniverses = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInUniverse ||
        (Array.isArray(state?.tickersInUniverse) &&
          state?.tickersInUniverse.length === 0)
      ) {
        getAllTickersInUniverse(userId)
      }
    },
    [state?.tickersInUniverse],
  )

  const getTickersOnlyInPortfolios = useCallback(
    (userId: string) => {
      if (
        !state?.tickersInPortfolio ||
        (Array.isArray(state?.tickersInPortfolio) &&
          state?.tickersInPortfolio.length === 0)
      ) {
        getTickersOnlyInPortfolio(userId)
      }
    },
    [state?.tickersInPortfolio],
  )

  useEffect(() => {
    clearD3Tips()
    if (!getCookie('userId') && getCookie('accessToken')) {
      userService
        .getUser(getCookie('email'))
        .then(res => {
          setCookieHelper('userId', res.data, EXPIRED_SECOND)
          getAllTickersInUniverses(res.data)
          setCookieHelper(
            'implied_rating_flag',
            res.implied_rating_flag,
            EXPIRED_SECOND,
          )
          const analysisFlag = res.analysis_flag ?? res?.data?.analysis_flag
          if (analysisFlag !== undefined && analysisFlag !== null) {
            setCookieHelper('analysis_flag', analysisFlag, EXPIRED_SECOND)
          }
          getTickersOnlyInPortfolios(res.data)
        })
        .catch(() => {})
    } else {
      getAllTickersInUniverses(getCookie('userId'))
      getTickersOnlyInPortfolios(getCookie('userId'))
    }
  }, [])

  useEffect(() => {
    setSelectedTab(getToggleValue(props.location.pathname))
    changeSelectedTab(getToggleValue(props.location.pathname))
  }, [props.location.pathname])

  const changeTabView = (event: React.ChangeEvent<{}>, newValue?: any) => {
    setSelectedTab(newValue)
    changeSelectedTab(newValue)
    if (newValue === 0) history.push(PORTFOLIO_HOME_PATHNAME)
    else if (newValue === 1) history.push(PORTFOLIO_LAST_WEEK_PATHNAME)
  }

  return (
    <>
      <div className={classes.container}>
        {state.loading && (
          <div className={classes.portfolioTable}>
            <ResponsiveArticle />
          </div>
        )}
        <div className={classes.pMobileControlCombo}>
          <BFTabs
            size="small"
            value={selectedTab}
            onChange={changeTabView}
            className={classes.tabsGroup}
          >
            <BFTab size="small" label="Today" value={0} />
            <BFTab size="small" label="Week to Date" value={1} />
          </BFTabs>

          <a href="#portfolioTable">
            <div className={classes.portfolioListContainer}>
              <FormatListBulletedIcon
                className={classes.FormatListBulletedIcon}
              />
              <span className={classes.portfolioListTitle}>Portfolio List</span>
            </div>
          </a>
        </div>
        {!state.loading && (
          <>
            {selectedTab === 0 ? (
              <>
                <div className={classes.pMPortfolioTitle}>
                  Portfolio
                  <HelpRounded
                    className={classes.toolTip}
                    key="1"
                    onClick={() => handleClickOpenTooltip()}
                  />
                </div>
                <div className={classes.subTitle}>
                  (Heat-Map of Risk in your Portfolio Companies)
                </div>
                <PortfolioTodayMobile
                  tickers={state.tickersInPortfolio}
                  riskType={selectedRiskTypeTab}
                />
              </>
            ) : (
              <PortfolioLastWeekMobile
                tickers={state.tickersInPortfolio}
                riskType={selectedRiskTypeTab}
              />
            )}
          </>
        )}
        <PortfolioTooltipModal
          open={openTooltip}
          handleClose={() => {
            setOpenTooltip(false)
          }}
        />
      </div>
    </>
  )
}

export default PortfolioPageMobile
